export default __webpack_public_path__ + "static/burn_packs-0b86b36eb9cebeedfd06e049888b2327.png";